import React from 'react';
import { store } from '../App';
import { history } from '../Router/createHistory';
import Header from '../Components/Header';

const authenticatedHOC = (ComposedComponent, asyncReducerNames) => {
  const authorized =
    localStorage.getItem('token') || sessionStorage.getItem('token');
  // handle authorized
  if (!authorized) {
    history.push('/login');
  } else {
    // inject the async reducer here.
    store.injectReducer(asyncReducerNames);
  }

  class AuthenticatedComposedComponent extends React.Component {
    render = () => (
      <>
        <Header />
        <ComposedComponent />
      </>
    );
  }

  return AuthenticatedComposedComponent;
};

export default authenticatedHOC;
